/**
 * Extract path from full URL
 * Example: 'https://www.skjewellery.com/product/sapphire-twilight-ring' -> '/product/sapphire-twilight-ring'
 */
export const extractPathFromUrl = (url: string): string => {
    if (!url) return '';
    
    try {
        // Try to parse as URL object
        const urlObj = new URL(url);
        return urlObj.pathname;
    } catch {
        // If URL parsing fails, use regex to extract path
        // This handles cases where URL might be malformed
        const match = url.match(/^https?:\/\/[^\/]+(\/.*)/);
        return match ? match[1] : url;
    }
};
